/**
 * CSS Variables & Global Styles
 * Generates the CSS string injected via <style> tag
 */
import { FONT, FONT_URL, DARK, LIGHT } from "./tokens";

export const buildCSS = () => `@import url('${FONT_URL}');
:root,[data-theme="dark"]{
  --bg:${DARK.bg};--surface-0:${DARK.surface0};--surface-1:${DARK.surface1};--surface-2:${DARK.surface2};--surface-3:${DARK.surface3};
  --border:${DARK.border};--border-strong:${DARK.borderStrong};--border-subtle:${DARK.borderSub};
  --text-1:${DARK.text1};--text-2:${DARK.text2};--text-3:${DARK.text3};
  --accent:#4B7FFA;--accent-hover:#3A6EE8;--accent-light:#6D96FB;--accent-glow:rgba(75,127,250,.22);--accent-subtle:rgba(75,127,250,.08);
  --danger:#F87171;--danger-glow:rgba(248,113,113,.18);
  --success:#34D399;--success-glow:rgba(52,211,153,.18);
  --shadow:${DARK.shadow};--shadow-lg:${DARK.shadowLg};--shadow-xl:${DARK.shadowXl};
  --shadow-card:0 2px 12px rgba(0,0,0,.45),0 1px 0 rgba(255,255,255,.03);
  --shadow-dialog:0 32px 80px rgba(0,0,0,.9),0 0 0 1px rgba(75,127,250,.10);
  --scrollbar-track:${DARK.scrollTrack};--scrollbar-thumb:${DARK.scrollThumb};
  --sidebar-bg:${DARK.sidebar};--sidebar-text:${DARK.text2};--sidebar-active:${DARK.text1};--sidebar-border:${DARK.sidebarBorder};
  --sidebar-shadow:1px 0 32px rgba(0,0,0,.8),1px 0 0 ${DARK.border};
  --sidebar-gradient:linear-gradient(180deg,#0C1019 0%,${DARK.sidebar} 100%);
  --header-bg:linear-gradient(180deg,rgba(15,21,40,.92) 0%,rgba(11,17,32,.88) 100%);--header-glow:0 4px 20px rgba(0,0,0,.35);
  --sidebar-w:240px;--sidebar-collapsed:64px;
  --gradient-sidebar:linear-gradient(180deg,#0C1019 0%,${DARK.sidebar} 100%);
  --card-gradient:linear-gradient(135deg,rgba(255,255,255,.025) 0%,rgba(255,255,255,.005) 60%,transparent 100%);
  --status-ok-bg:rgba(52,211,153,.08);--status-ok-border:rgba(52,211,153,.22);
  --status-fail-bg:rgba(248,113,113,.08);--status-fail-border:rgba(248,113,113,.22);
  --status-total-bg:rgba(75,127,250,.08);--status-total-border:rgba(75,127,250,.22);
  --status-success-bg:rgba(52,211,153,.10);--status-error-bg:rgba(248,113,113,.10);--status-processing-bg:rgba(75,127,250,.10);
  --config-target-bg:rgba(75,127,250,.10);
  --ctrl-h:36px;--ctrl-h-sm:30px;--ctrl-h-lg:40px;
  --ctrl-radius:8px;--ctrl-radius-sm:6px;
  --ctrl-border:1px solid var(--border);
  --ctrl-bg:${DARK.surface2};
  --ctrl-px:12px;--ctrl-gap:8px;
  --ctrl-font:13px;--ctrl-font-sm:12px;
  --card-radius:12px;--card-border:1px solid var(--border);--card-bg:var(--surface-1);--card-px:16px;--card-py:14px;
  --section-gap:16px;--toolbar-gap:10px;
  color-scheme:dark;
}
[data-theme="light"]{
  --bg:${LIGHT.bg};--surface-0:${LIGHT.surface0};--surface-1:${LIGHT.surface1};--surface-2:${LIGHT.surface2};--surface-3:${LIGHT.surface3};
  --border:${LIGHT.border};--border-strong:${LIGHT.borderStrong};--border-subtle:${LIGHT.borderSub};
  --text-1:${LIGHT.text1};--text-2:${LIGHT.text2};--text-3:${LIGHT.text3};
  --accent:#B45309;--accent-hover:#92400E;--accent-light:#D97706;--accent-glow:rgba(180,83,9,.12);--accent-subtle:rgba(180,83,9,.07);
  --danger:#DC2626;--danger-glow:rgba(220,38,38,.10);
  --success:#16A34A;--success-glow:rgba(22,163,74,.10);
  --warning:#D97706;--warning-glow:rgba(217,119,6,.10);
  --shadow:${LIGHT.shadow};--shadow-lg:${LIGHT.shadowLg};--shadow-xl:${LIGHT.shadowXl};--shadow-card:0 1px 3px rgba(80,60,30,.05),0 4px 16px rgba(80,60,30,.05);
  --scrollbar-track:transparent;--scrollbar-thumb:${LIGHT.scrollThumb};
  --sidebar-bg:${LIGHT.sidebar};--sidebar-text:${LIGHT.sidebarText};--sidebar-active:${LIGHT.sidebarActive};--sidebar-border:${LIGHT.sidebarBorder};
  --sidebar-shadow:2px 0 16px rgba(44,37,32,.15);
  --sidebar-gradient:linear-gradient(180deg,#1F1A16 0%,${LIGHT.sidebar} 100%);
  --header-bg:linear-gradient(180deg,rgba(255,253,249,.95) 0%,rgba(240,235,228,.92) 100%);--header-glow:0 2px 12px rgba(80,60,30,.06);
  --sidebar-w:240px;--sidebar-collapsed:64px;
  --gradient-sidebar:linear-gradient(180deg,#1F1A16 0%,${LIGHT.sidebar} 100%);
  --card-gradient:linear-gradient(135deg,rgba(255,253,249,.6) 0%,rgba(255,253,249,.2) 55%,transparent 100%);
  --status-ok-bg:rgba(22,163,74,.08);--status-ok-border:rgba(22,163,74,.22);
  --status-fail-bg:rgba(220,38,38,.08);--status-fail-border:rgba(220,38,38,.22);
  --status-total-bg:rgba(180,83,9,.08);--status-total-border:rgba(180,83,9,.22);
  --config-target-bg:rgba(180,83,9,.08);
  --status-warn-bg:rgba(217,119,6,.08);--status-warn-border:rgba(217,119,6,.22);
  --ctrl-h:36px;--ctrl-h-sm:30px;--ctrl-h-lg:40px;
  --ctrl-radius:8px;--ctrl-radius-sm:6px;
  --ctrl-border:1px solid var(--border);
  --ctrl-bg:var(--surface-0);
  --ctrl-px:12px;--ctrl-gap:8px;
  --ctrl-font:13px;--ctrl-font-sm:12px;
  --card-radius:12px;--card-border:1px solid var(--border);--card-bg:var(--surface-0);--card-px:16px;--card-py:14px;
  --section-gap:16px;--toolbar-gap:10px;
  color-scheme:light;
}
@keyframes pulse{0%,100%{opacity:1}50%{opacity:.3}}
@keyframes fadeIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}
@keyframes slideIn{from{opacity:0;transform:translateX(-8px)}to{opacity:1;transform:translateX(0)}}
@keyframes slideOut{from{opacity:1;transform:translateX(0)}to{opacity:0;transform:translateX(-10px)}}
@keyframes slideInRight{from{opacity:0;transform:translateX(10px)}to{opacity:1;transform:translateX(0)}}
@keyframes shimmer{0%{background-position:-400% 0}100%{background-position:400% 0}}
@keyframes glowPulse{0%,100%{box-shadow:0 0 0 rgba(75,127,250,0)}50%{box-shadow:0 0 28px rgba(75,127,250,.18)}}
@keyframes spin{to{transform:rotate(360deg)}}
@keyframes accentBorderIn{from{border-color:var(--border)}to{border-color:rgba(75,127,250,.5)}}
@keyframes accentGlow{0%{box-shadow:0 0 0 rgba(75,127,250,0)}100%{box-shadow:0 0 20px rgba(75,127,250,.15)}}
*{box-sizing:border-box;margin:0;padding:0}
html,body,#root{min-height:100vh;min-height:100dvh}
body{background:var(--bg);color:var(--text-1);font-family:${FONT};-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-size:14px;line-height:1.5;font-variant-numeric:tabular-nums}
/* Scrollbar */
::-webkit-scrollbar{width:4px;height:4px}
::-webkit-scrollbar-track{background:transparent}
::-webkit-scrollbar-thumb{background:var(--scrollbar-thumb);border-radius:4px}
::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,0.22)}
[data-theme="dark"] ::-webkit-scrollbar-thumb:hover{background:rgba(255,255,255,0.14)}
/* Form elements */
input,select,button,textarea,option{outline:none;font-family:${FONT}}
input,select,textarea{height:var(--ctrl-h);padding:0 var(--ctrl-px);background:var(--ctrl-bg);border:var(--ctrl-border);border-radius:var(--ctrl-radius);color:var(--text-1);font-size:var(--ctrl-font);transition:border-color .15s,box-shadow .15s}
select{font-size:inherit;padding-right:28px}
button{font-family:${FONT};cursor:pointer;transition:all .12s ease}
button:active:not(:disabled){transform:scale(.98)}
input:focus,select:focus,textarea:focus{border-color:var(--accent)!important;box-shadow:0 0 0 3px var(--accent-glow)!important;outline:none}
input::placeholder{color:var(--text-3)}
/* Cards - depth + hover glow */
.card-hover{transition:border-color .2s ease,box-shadow .2s ease,transform .18s ease}
.card-hover:hover{border-color:rgba(75,127,250,.4)!important;transform:translateY(-2px);box-shadow:0 8px 32px rgba(75,127,250,.12),0 0 0 1px rgba(75,127,250,.2)}
[data-theme="dark"] .card-hover:hover{box-shadow:0 16px 48px rgba(0,0,0,.8),0 0 0 1px rgba(75,127,250,.28),0 0 40px rgba(75,127,250,.07)}
[data-theme="light"] .card-hover:hover{border-color:rgba(180,83,9,.35)!important;box-shadow:0 8px 32px rgba(180,83,9,.10),0 0 0 1px rgba(180,83,9,.18)}
/* Elevation utility classes - dark-mode first, light-mode adapts via color-scheme */
.elevation-0{box-shadow:none}
.elevation-1{box-shadow:0 1px 4px rgba(0,0,0,.55),0 0 0 1px var(--border)}
.elevation-2{box-shadow:0 4px 16px rgba(0,0,0,.65),0 0 0 1px var(--border-strong)}
.elevation-3{box-shadow:0 8px 32px rgba(0,0,0,.75),0 0 0 1px rgba(75,127,250,.12)}
.glass-border{border:1px solid var(--border)!important;backdrop-filter:blur(12px)}
[data-theme="dark"] .glass-border{border:1px solid rgba(255,255,255,.06)!important}
/* Table rows */
.row-hover{transition:background .1s ease;cursor:pointer}.row-hover:hover{background:var(--surface-2)!important}
/* Shimmer */
[data-theme="dark"] .shimmer-bg{background:linear-gradient(90deg,${DARK.surface1} 0%,${DARK.surface2} 40%,${DARK.surface3} 50%,${DARK.surface2} 60%,${DARK.surface1} 100%);background-size:400% 100%;animation:shimmer 2s infinite}
[data-theme="light"] .shimmer-bg{background:linear-gradient(90deg,${LIGHT.surface2} 0%,${LIGHT.surface3} 40%,${LIGHT.surface2} 50%,${LIGHT.surface3} 60%,${LIGHT.surface2} 100%);background-size:400% 100%;animation:shimmer 2s infinite}
/* Sidebar navigation buttons */
.sidebar-btn{width:100%;height:var(--ctrl-h);padding:0 14px;border-radius:var(--ctrl-radius);border:none;font-size:var(--ctrl-font);font-weight:500;cursor:pointer;background:transparent;color:var(--sidebar-text);transition:all .15s ease;text-align:left;display:flex;align-items:center;gap:10px;font-family:${FONT}}
.sidebar-btn:hover{color:var(--sidebar-active);background:rgba(75,127,250,.09)}
.sidebar-btn.active{color:var(--accent);background:rgba(75,127,250,.12);font-weight:600}
[data-theme="light"] .sidebar-btn:hover{background:rgba(180,83,9,.09)}
[data-theme="light"] .sidebar-btn.active{background:rgba(180,83,9,.14)}
.sidebar-btn svg{flex-shrink:0;opacity:.5;transition:opacity .15s}.sidebar-btn:hover svg,.sidebar-btn.active svg{opacity:1}
/* Toolbar */
.toolbar{display:flex;align-items:center;gap:var(--toolbar-gap);flex-wrap:wrap}
.toolbar>input,.toolbar>select,.toolbar>button{margin:0}
/* Selection highlight */
::selection{background:rgba(75,127,250,.28);color:var(--text-1)}
[data-theme="light"] ::selection{background:rgba(180,83,9,.20)}
/* Dark mode radial glow - subtle blue accent at top of canvas */
[data-theme="dark"] body{background:radial-gradient(ellipse 120% 50% at 50% -8%,rgba(75,127,250,.09) 0%,${DARK.bg} 60%)}
/* Focus-visible ring */
:focus-visible{outline:2px solid rgba(75,127,250,.6);outline-offset:2px}
button:focus-visible,a:focus-visible{outline:2px solid rgba(75,127,250,.6);outline-offset:2px}
[data-theme="light"] :focus-visible{outline-color:rgba(180,83,9,.5)}
[data-theme="light"] button:focus-visible,[data-theme="light"] a:focus-visible{outline-color:rgba(180,83,9,.5)}
/* Header accent line */
.header-bar{position:relative}
.header-bar::after{content:'';position:absolute;bottom:0;left:0;right:0;height:1px;background:linear-gradient(90deg,transparent 0%,var(--accent) 50%,transparent 100%);opacity:.2;pointer-events:none}
/* Sidebar shadow */
[data-theme="dark"] aside{box-shadow:var(--sidebar-shadow)}
@media(max-width:768px){
  body,#root{overflow-x:hidden;max-width:100vw}
  .card-hover:hover{box-shadow:none;transform:none}
  .mobile-hide{display:none!important}
  .mobile-full{width:100%!important}
  .mobile-stack{flex-direction:column!important}
  .toolbar-scroll{overflow-x:auto;-webkit-overflow-scrolling:touch;scrollbar-width:none}
  .toolbar-scroll::-webkit-scrollbar{display:none}
  .table-scroll-mobile{overflow-x:auto;-webkit-overflow-scrolling:touch}
}
/* Tooltip utility */
.ux-tooltip{position:relative}
.ux-tooltip[data-tip]:hover::after{content:attr(data-tip);position:absolute;bottom:calc(100% + 6px);left:50%;transform:translateX(-50%);background:var(--surface-3);color:var(--text-1);border:1px solid var(--border-strong);border-radius:6px;padding:4px 8px;font-size:11px;white-space:nowrap;pointer-events:none;z-index:9999;box-shadow:var(--shadow-lg);animation:fadeInTip 0.12s ease;font-family:${FONT}}
.ux-tooltip[data-tip]:hover::before{content:"";position:absolute;bottom:calc(100% + 1px);left:50%;transform:translateX(-50%);border:5px solid transparent;border-top-color:var(--border-strong);pointer-events:none;z-index:9999}
@keyframes fadeInTip{from{opacity:0;transform:translateX(-50%) translateY(4px)}to{opacity:1;transform:translateX(-50%) translateY(0)}}
/* Quick-preview panel */
.space-preview-panel{animation:slideInRight 0.2s ease}
/* Hover action buttons in table rows */
.row-actions{opacity:0;transition:opacity .15s ease}
.row-hover:hover .row-actions{opacity:1}
/* Anomalie badge pulse */
@keyframes anomaliePulse{0%,100%{box-shadow:0 0 0 0 rgba(248,113,113,.4)}70%{box-shadow:0 0 0 6px rgba(248,113,113,0)}}
.anomalie-badge{animation:anomaliePulse 2s infinite}
`;
